import * as types from '../constants/ActionTypes';

export function reportImageSize(imageId, size) {
  return {
    type: types.REPORT_IMAGE_SIZE,
    imageId,
    size
  };
}

export function reportImageDimensions(imageId, width, height) {
  return {
    type: types.REPORT_IMAGE_DIMENSIONS,
    imageId,
    width,
    height
  };
}

export function showDetails(transformation, format, details) {
  return {
    type: types.SHOW_DETAILS,
    transformation,
    format,
    details
  };
}

export function resetDemoImage(imageId) {
  return {
    type: types.RESET_DEMO_IMAGE,
    imageId
  };
}


/** WEBPACK FOOTER **
 ** ./src/js/actions/DemoImageActions.js
 **/